export default (node) => {
  /**
   * Data + elements
   */
  const animationSections = node.dataset.animationSections;
  //imagesAnimationSections is a comma separated list of section ids
  const animationSectionsArray = animationSections ? animationSections.split(',').map(section => `.${section}`).flat() : '';
  const enableAnimation = node.dataset.enableAnimation;
  const allAnimationSections = animationSectionsArray.length > 0 ? document.querySelectorAll(animationSectionsArray) : null;
  const ratioThreshold = allAnimationSections.length < 4 ? 0 : 0.4;
  /**
   * Functions
   */
  // add intersection observer to the section when 40% of the section is visible, when the user scrolls down the page
  const addIntersectionObserver = (section) => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= ratioThreshold) {

          // animate images
          const imagesVideos = section.querySelectorAll('img, video');
          imagesVideos.forEach(imageVideo => {
            imageVideo.classList.add('!animate-scale-1000');
          });

          // animate text
          const allTexts = section.querySelectorAll('.text-animation');
          allTexts.forEach(textElement => {
            textElement.classList.add('!text-animation-visible');
          });

          // animate product grid
          const productGrid = section.querySelectorAll('.grid-animation');
          if (productGrid) {
            productGrid.forEach(grid => {
              const items = grid.querySelectorAll(':scope > *'); // direct children only

              // Stagger: left-to-right order = DOM order
              const step = 300; // ms between items (tweak to taste)
              items.forEach((el, i) => {
                el.style.animationDelay = `${i * step}ms`;
              });
              grid.classList.add('grid-animation-visible');
            })

          }

          // Stop observing after first trigger
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: [0.4]
    });

    observer.observe(section);
  };
  /**
   * Init
   */
  const init = () => {

    // if enableAnimation is true, then add the intersection observer to the animation sections
    if (enableAnimation && allAnimationSections) {
      allAnimationSections.forEach((section) => {
        addIntersectionObserver(section);
      });
    }
  };

  init();
};
